module.exports = __webpack_public_path__ + "static/img/20180414165909.8eee3edf.jpg";